module.exports = __webpack_public_path__ + "static/media/Gia02_icon.b0df866c.svg";